export default "__VITE_ASSET__C7zwU8fo__"